import React from 'react';
import { Container, Typography, Box, Paper, Link } from '@mui/material';

const AboutPage = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        About
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Data Sources
        </Typography>
        <Box component="ul" sx={{ pl: 2 }}>
          <li>
            <Typography variant="body1">
              <strong>ASC (Autism Sequencing Consortium):</strong> Fu et al., Nature Genetics 2022. Rare coding variant associations from exome sequencing of autism trios.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>SCHEMA (Schizophrenia):</strong> Singh et al., Nature 2022. Website:{' '}
              <Link href="https://schema.broadinstitute.org" target="_blank" rel="noopener">
                https://schema.broadinstitute.org
              </Link>
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>BipEx (Bipolar Disorder):</strong> Palmer et al., Nature Genetics 2022
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Epi25 (Epilepsy):</strong> Epi25 Collaborative, Nature Genetics 2023
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>MDD (Major Depressive Disorder):</strong> Cai et al., Nature Human Behaviour 2024. EHR-based case-control exome analysis (450K samples).
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>NDD (Neurodevelopmental Disorders):</strong> Kaplanis et al., Nature 2020 (DDD Study). De novo variant enrichment analysis.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>ADHD:</strong> Huang et al., Nature Communications 2024. Rare coding variant burden analysis.
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>Cognition:</strong> Rare variant associations with cognitive phenotypes (VNR, RT, Educational Attainment).
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <strong>OCD (Obsessive-Compulsive Disorder):</strong> Cappi et al. TADA analysis of OCD + chronic tic disorders.
            </Typography>
          </li>
        </Box>
      </Paper>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Methodology
        </Typography>
        <Typography variant="body1" paragraph>
          This webapp aggregates rare variant genetic association data from multiple large-scale
          sequencing studies across 9 psychiatric and neurodevelopmental disorders. Genes are ranked
          by statistical significance (p-value or q-value) with secondary consideration given to
          effect size (odds ratio).
        </Typography>
        <Typography variant="body1">
          Significance thresholds:
        </Typography>
        <Box component="ul" sx={{ pl: 2 }}>
          <li>Genome-wide significant: p &lt; 5&times;10&#8315;&#8312;</li>
          <li>Highly significant: p &lt; 1&times;10&#8315;&#8310;</li>
          <li>Significant: p &lt; 0.05</li>
        </Box>
      </Paper>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Gene Reference
        </Typography>
        <Typography variant="body1">
          Gene information is sourced from HGNC (HUGO Gene Nomenclature Committee) protein-coding
          gene annotations. Constraint metrics from gnomAD v4.0.
        </Typography>
      </Paper>
    </Container>
  );
};

export default AboutPage;
